import React from "react";
import SvgIcon from "@material-ui/core/SvgIcon";

export interface Props {
  className?: string;
}

const MapIcon = (props: Props) => {
  const { className } = props;

  return (
    <SvgIcon className={className} viewBox="0 0 20 20">
      <g transform="matrix(1 0 0 1 -400 -488 )">
        <path
          d="M 20 0.555555555555556  C 20 0.25  19.75 0  19.4444444444444 0  C 19.3833333333333 0  19.3277777777778 0.00555555555555544  19.2722222222222 0.0277777777777777  L 13.3333333333333 2.33333333333333  L 6.66666666666667 0  L 0.405555555555556 2.11111111111111  C 0.172222222222222 2.18888888888889  0 2.38888888888889  0 2.64444444444445  L 0 19.4444444444444  C 0 19.75  0.25 20  0.555555555555556 20  C 0.616666666666667 20  0.672222222222222 19.9944444444444  0.727777777777778 19.9722222222222  L 6.66666666666667 17.6666666666667  L 13.3333333333333 20  L 19.6 17.8944444444444  C 19.8333333333333 17.8111111111111  20 17.6111111111111  20 17.3555555555556  L 20 0.555555555555556  Z M 13 4.56111111111111  L 13 17.7777777777778  L 7 15.4388888888889  L 7 2.22222222222222  L 13 4.56111111111111  Z "
          fillRule="nonzero"
          fill="#61c69e"
          stroke="none"
          transform="matrix(1 0 0 1 400 488 )"
        />
      </g>
    </SvgIcon>
  );
};

export default MapIcon;
